'use client';

import React, { type FC } from 'react';
import { formatCreditsNumber, formatCreditsShort } from '../utils/formatters';
import { CreditsChangeFlash } from './CreditsChangeFlash';
import { FaCoins } from './icons';

interface CreditsProps {
  amount: number;
  className?: string;
  showIcon?: boolean;
  iconSize?: number | string;
  iconOnly?: boolean;
  muted?: boolean;
  compact?: boolean;
  align?: 'center' | 'baseline';
  animateChange?: boolean;
}

export const Credits: FC<CreditsProps> = ({ amount, className, showIcon = true, iconSize = 12, iconOnly = false, muted = false, compact = false, align = 'center', animateChange = false }) => {
  const format = compact ? formatCreditsShort : formatCreditsNumber;

  return (
    <span className={`inline-flex ${align === 'baseline' ? 'items-baseline' : 'items-center'} gap-1 ${className || ''}`}>
      {!iconOnly &&
        (animateChange ? <CreditsChangeFlash amount={amount} format={format} /> : format(amount))}
      {showIcon && (
        <FaCoins className={`${muted ? 'text-gray-400' : 'text-price'} shrink-0`} size={iconSize} />
      )}
    </span>
  );
};
